import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type EventStatus = "end" | "not_start";

interface Props {
    open: boolean;
    status: EventStatus;
    onClose?: () => void;
}

export const EventModal = ({ open, status, onClose }: Props) => {
    const handleClose = () => {
        onClose?.();
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                p: "18px",
                borderRadius: "12px",
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography
                    sx={{
                        color: "#000",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "normal",
                    }}
                >
                    {status === "end" ? "活動已結束" : "活動未開始"}
                </Typography>
                <IconButton onClick={handleClose}>
                    <CloseIcon
                        sx={{
                            width: "16px",
                            height: "16px",
                            color: "#9099B0",
                        }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent
                sx={{
                    color: "#000",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "normal",
                }}
            >
                {status === "end" ? "活動已結束。" : "活動未開始，請在活動開始後再登入。"}
            </DialogContent>
            <DialogActions>
                <Button
                    sx={{
                        py: "8px",
                        borderRadius: "6px",
                        backgroundColor: "#269FFF",
                        width: "100%",
                        color: "#fff",
                        fontSize: "14px",
                        textAlign: "center",
                        fontStyle: "normal",
                        fontWeight: "400",
                        lineHeight: "normal",
                        "&:hover": {
                            backgroundColor: "#269FFF",
                        }
                    }}
                    onClick={handleClose}
                >
                    確認
                </Button>
            </DialogActions>
        </Dialog>
    )
}

